import type { LinkTypeObject } from '~~/shared-components/types/Link'

export const linkTypesQuery = () =>
  queryOptions({
    queryKey: ['link-types'],
    queryFn: async ({ signal }): Promise<{ [key in LinkTypeObject['value']]: LinkTypeObject }> => {
      const res = await useCustomFetch<{
        data: { [key in LinkTypeObject['value']]: LinkTypeObject }
      }>({ url: '/enums/link-types', signal })
      return res?.data.value.data
    },
  })
